export default "__VITE_ASSET__ca4650cb__"